import { guideArticles } from '@/mocks/home';

export default function GuideCollection() {
  return (
    <section id="guides" className="w-full bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="font-label text-xs tracking-[0.2em] text-primary-600">COLLECTION / 专题合集</span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              入口·下载·在线看 专题合集
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-7 text-foreground-600">
              把入口、下载与在线看相关的经验整理成一组短文，按需要的方向直接翻阅。
            </p>
          </div>
          <span className="font-label text-xs text-foreground-500">共 {guideArticles.length} 篇 · 持续补充</span>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 lg:gap-5">
          {guideArticles.map((article) => (
            <a
              key={article.id}
              href="#guides"
              className="group flex cursor-pointer flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 md:p-6"
            >
              <div className="flex items-center justify-between">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-2.5 py-1 font-label text-[11px] text-secondary-900">
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className={`${article.icon} text-[11px]`} />
                  </span>
                  {article.category}
                </span>
                <span className="font-label text-[11px] text-foreground-400">{article.readTime}</span>
              </div>

              <h3 className="mt-4 font-heading text-base font-semibold leading-7 text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
                {article.title}
              </h3>
              <p className="mt-2 flex-1 text-xs leading-6 text-foreground-600 md:text-sm">{article.excerpt}</p>

              <span className="mt-5 flex items-center gap-1 text-xs font-medium text-primary-700">
                阅读全文
                <span className="flex h-3.5 w-3.5 items-center justify-center transition-transform group-hover:translate-x-0.5">
                  <i className="ri-arrow-right-line text-[11px]" />
                </span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}